import styled from "styled-components";
import { flexCenter } from "../../styles";
import { fontSize_SM, fontSize_XXL } from "../../customFonts";

export const FooterSection = styled.div`
  width: 100%;
  background-color: #16191b;
  color: white;
  padding: 30px 0;

  h5 {
    padding-bottom: 26px;
    font-weight: 700;
    ${fontSize_XXL};
    color: white;
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      padding-bottom: 16px;
    }
  }

  p,
  li {
    font-weight: 400;
    ${fontSize_SM};
  }

  a {
    color: white;
  }
`;

export const CopyrightBar = styled.div`
  background-color: #16191b;
  ${flexCenter};
  padding: 6px 0;

  p {
    text-align: center;
    margin: 0;
    color: white;
    font-size: 12px;
  }
`;
